import type { TripParticipant } from '@my-fullstack-app/itinerary-types';
import { FallbackImage } from '../../design/FallbackImage';
import { getParticipantDisplayName } from '../../../lib/participant-utils';

interface Props {
  participant: Pick<TripParticipant, 'id' | 'displayName' | 'avatarUrl'>;
  size: number;
}

/**
 * Visual identity for a `TripParticipant`. Shows the linked user's
 * avatar when one is available, otherwise falls back to the
 * participant's first initial on a deterministic gradient — the
 * same FallbackImage pattern used for place photos. The gradient is
 * seeded by `participant.id` (not the display name) so renames
 * don't flip the colour for the same person.
 */
export function ParticipantAvatar({ participant, size }: Props) {
  return (
    <FallbackImage
      uri={participant.avatarUrl ?? null}
      label={getParticipantDisplayName(participant)}
      seed={participant.id}
      style={{ width: size, height: size }}
      borderRadius={size / 2}
      letterSize={Math.max(10, Math.round(size * 0.45))}
    />
  );
}
